export const header = {
  headerTitle: 'User Profile',
  headerDescription: '',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
